import { useState, useEffect } from "react";

import { getProjectID } from "../utils/misc";
import { getUserRolesInApp } from "../utils/api";

const defaultUser = {
    id: -1,
    username: 'guest',
    name: 'guest',
    role: 'guest',    // User role in the app
    role: 'citizen', // User role for the current project
};

export const useUserSession = () => {
    const [user, setUser] = useState(defaultUser);
    const [projectID, setProjectID] = useState(getProjectID());

    const getUserFromAppDatasetAttribute = () => {
        const appElement = document.getElementById('visor-app');
        const userData = JSON.parse(appElement.getAttribute('data-user'));
        return userData;
    }

    useEffect(() => {
        let user = getUserFromAppDatasetAttribute();
        if (user) {
            setUser(user);
        }

        const abortController = new AbortController();
        getUserRolesInApp(abortController.signal).then(response => {
            if (response.ok) {
                response.json().then(obj => {
                    setUser({
                        ...user,
                        role: obj.roles[0] || 'guest',
                    });
                });
            }
        });

  

        return () => {
            abortController.abort();
        }
    }, [projectID]);

    /**
     * Checks if the current user has the specified role
     * 
     * @param {String|Array} role the role or roles to check
     * @returns {Boolean}
     */
    const hasRole = (role) => {

        if (!user) {
            return false;
        }

        if (Array.isArray(role)) {
            return role.includes(user.role);
        }

        return user.role === role;
    };


    return {
        session: {
            user,
            hasRole,
          
        }
    };
};